/**
 * accesorios-track-autofill.js
 * Auto-fills the AWB tracking number on /pages/track-order from URL params
 * and triggers the embedded tracking widget's lookup.
 *
 * Triggered from WhatsApp template buttons:
 *   https://accesorios.in/pages/track-order?awb=30125720192335
 *
 * Loaded only on the track-order page via theme.liquid conditional.
 */
(function () {
  'use strict';

  // Belt-and-braces: also self-guard by pathname in case file gets cached on other routes
  if (!/\/pages\/track-order/i.test(window.location.pathname)) return;

  function getParam() {
    var p = new URLSearchParams(window.location.search);
    return (
      p.get('awb') || p.get('tracking') || p.get('tracking_number') || p.get('trackingnumber') ||
      p.get('order') || p.get('order_number') || p.get('order_id') ||
      p.get('phone') || p.get('mobile') ||
      p.get('id') || ''
    ).trim();
  }

  function findInput() {
    return document.querySelector(
      'input[name="tracking_number"], input[name="awb"], input[name="tracking"], ' +
      'input[name="trackingnumber"], input[id*="track" i], input[placeholder*="track" i], ' +
      'input[placeholder*="awb" i], main input[type="search"], main form input[type="text"]'
    );
  }

  function findSubmit(input) {
    var form = input && input.closest ? input.closest('form') : null;
    if (form) {
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (btn) return { btn: btn, form: form };
    }
    // tracking-dashboard: button is a sibling in the same row container, type="button"
    var parent = input ? input.parentElement : null;
    if (parent) {
      var sibBtn = parent.querySelector('button');
      if (sibBtn) return { btn: sibBtn, form: null };
    }
    var anyBtn = document.querySelector(
      'main button[type="submit"], main .track-button, main [data-track], main #track-button'
    );
    return { btn: anyBtn, form: form };
  }

  function fill(awb) {
    var input = findInput();
    if (!input) return false;

    input.value = awb;
    input.dispatchEvent(new Event('input',  { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    var s = findSubmit(input);
    if (s.btn) {
      setTimeout(function () { s.btn.click(); }, 350);
    } else if (s.form) {
      setTimeout(function () { s.form.submit(); }, 350);
    }
    return true;
  }

  function start() {
    var val = getParam();
    if (!val) return;

    if (fill(val)) return;

    // Tracking widget loads async — retry until input shows up (max ~5s)
    var attempts = 0;
    var t = setInterval(function () {
      attempts++;
      if (fill(val) || attempts > 20) clearInterval(t);
    }, 250);

    // Also re-attempt when DOM mutates (some widgets render late)
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () {
        if (fill(val)) obs.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 8000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();